import { render, staticRenderFns } from "./MenuToppingOption.vue?vue&type=template&id=0118b730&lang=pug&"
import script from "./MenuToppingOption.vue?vue&type=script&lang=js&"
export * from "./MenuToppingOption.vue?vue&type=script&lang=js&"
import style0 from "./MenuToppingOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports